import { render, staticRenderFns } from "./syncComment.vue?vue&type=template&id=64a67368&scoped=true&"
import script from "./syncComment.vue?vue&type=script&lang=js&"
export * from "./syncComment.vue?vue&type=script&lang=js&"
import style0 from "./syncComment.vue?vue&type=style&index=0&id=64a67368&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a67368",
  null
  
)

export default component.exports